export default __webpack_public_path__ + "static/media/delivery-truck.10a0cc90.png";